import React, { useState } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ReplayIcon from "@mui/icons-material/Replay";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Link from "@mui/material/Link";
import {
  friendlyTransactionType,
  summarizeSiigoError,
  formatCurrency,
  formatDateTime,
  prettyPrintPayload,
} from "./siigoHelpers";

export default function FailedOutboxRow({ record, onRetry, retrying, onShowError }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <React.Fragment>
      <TableRow hover>
        <TableCell sx={{ minWidth: 180 }}>
          <Typography variant="body2" fontWeight={600}>
            {friendlyTransactionType(record.transactionType)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          {record.creditOldId ? (
            <Chip label={`Crédito #${record.creditOldId}`} size="small" sx={{ backgroundColor: "#e8eaf6" }} />
          ) : (
            "—"
          )}
        </TableCell>
        <TableCell>
          {record.clienteNombre || record.clienteDocumento || "—"}
        </TableCell>
        <TableCell align="right">{formatCurrency(record.monto)}</TableCell>
        <TableCell align="center">{record.accountingDate || "—"}</TableCell>
        <TableCell align="center">
          <Chip
            label={`${record.attempts} intento${record.attempts === 1 ? "" : "s"}`}
            size="small"
            color={record.attempts >= 3 ? "error" : "default"}
          />
        </TableCell>
        <TableCell sx={{ maxWidth: 280 }}>
          <Typography variant="body2" color="error.main">
            {summarizeSiigoError(record.errorDetail)}
          </Typography>
          {record.errorDetail && onShowError && (
            <Link
              component="button"
              type="button"
              variant="caption"
              underline="hover"
              onClick={() => onShowError(record.errorDetail)}
              sx={{ display: "inline-flex", alignItems: "center", gap: 0.3, mt: 0.5, color: "#1565c0" }}
            >
              <VisibilityIcon sx={{ fontSize: 14 }} />
              Ver detalle
            </Link>
          )}
        </TableCell>
        <TableCell align="center">{formatDateTime(record.createdDate)}</TableCell>
        <TableCell align="center">
          <Box display="flex" gap={0.5} justifyContent="center">
            <Tooltip title="Reintentar envío a Siigo">
              <span>
                <IconButton
                  size="small"
                  onClick={() => onRetry(record.id)}
                  disabled={retrying}
                  sx={{ color: "#1565c0" }}
                >
                  {retrying ? <CircularProgress size={18} /> : <ReplayIcon fontSize="small" />}
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title={expanded ? "Ocultar detalle técnico" : "Ver detalle técnico"}>
              <IconButton size="small" onClick={() => setExpanded((v) => !v)}>
                {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
          </Box>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={9} sx={{ p: 0, border: expanded ? undefined : "none" }}>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box sx={{ p: 2, backgroundColor: "#fafafa" }}>
              <Typography variant="caption" color="text.secondary" display="block" mb={1}>
                Detalle técnico (uso interno de sistemas)
              </Typography>
              <Box
                component="pre"
                sx={{
                  fontSize: "0.7rem",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-all",
                  margin: 0,
                  maxHeight: 240,
                  overflowY: "auto",
                }}
              >
                {prettyPrintPayload(record.payloadRaw)}
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
